import { createFileRoute } from '@tanstack/react-router';
import { PasswordResetLandingPage } from '@pages/recovery';

export const Route = createFileRoute('/$locale/recovery/password-reset/$recoveryRequestId')({
  component: PasswordResetRoute,
});

function PasswordResetRoute() {
  const { locale, recoveryRequestId } = Route.useParams();
  return (
    <PasswordResetLandingPage
      locale={locale as 'en' | 'ru'}
      recoveryRequestId={recoveryRequestId}
    />
  );
}
